module.exports = __webpack_public_path__ + "static/media/loader.cac6f4f6.gif";